import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import App from "./App";
import { store, persistor } from "./store";
import "./index.css";
import "leaflet/dist/leaflet.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

 axios.defaults.baseURL = "https://aeroviewbackend.dockyardsoftware.com/";
  // axios.defaults.baseURL = "https://aeroviewtestbackend.dockyardsoftware.com/";
//axios.defaults.baseURL = "http://172.30.30.96:2500/";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);

// Register service worker for PWA (caching / offline)
serviceWorkerRegistration.register();
